<template>
  <ActiveMarketsItemAdvanced
      v-if="market"
      :market="market"
      :checkOnlyDisable="false"
  >
  </ActiveMarketsItemAdvanced>
  <div v-else class="text-xs-center pa-3">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
    <h1>Loading...</h1>
  </div>
</template>

<script>
import ActiveMarketsItemAdvanced from "./ActiveMarketsItemAdvanced";
import axios from "axios";

export default {
  components: {
    ActiveMarketsItemAdvanced
  },
  props: ["name"],
  data: function() {
    return {
      market: null
    };
  },
  computed: {},
  created: async function() {
    await axios.get("/api/v1/markets?name=" + this.name).then(res => {
      this.market = res.data.markets[0];
    });
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/markets/MarketAllocationsExpandedSettings.vue